import React from 'react';
import { number, shape, string } from 'prop-types';
import { Bullets, Container, Progress, Label } from './linear-progress.styles';

const getBullets = ({
  quantity
}) => quantity && Array.from(Array(quantity).keys()).map(key => /*#__PURE__*/React.createElement("div", {
  key: key,
  "data-testid": "linear-progress-bullet"
}));

const hasBullets = bullets => Boolean(Object.keys(bullets).length);

const LinearProgress = ({
  bullets,
  value,
  max,
  color,
  label,
  height,
  width
} = {}) => {
  return /*#__PURE__*/React.createElement(Container, {
    color: color,
    width: width,
    height: height,
    "data-testid": "linear-progress"
  }, label && /*#__PURE__*/React.createElement(Label, {
    color: color,
    value: value,
    "data-testid": "linear-progress-label"
  }, label), /*#__PURE__*/React.createElement(Progress, {
    max: max,
    color: color,
    width: width,
    height: height,
    value: value,
    "data-label": label
  }, label), hasBullets(bullets) && /*#__PURE__*/React.createElement(Bullets, {
    bullets: bullets,
    height: height
  }, getBullets(bullets)));
};

process.env.NODE_ENV !== "production" ? LinearProgress.propTypes = {
  value: number.isRequired,
  label: string,
  max: number,
  color: string,
  width: string,
  height: string,
  bullets: shape({
    quantity: number,
    size: number,
    color: string
  })
} : void 0;
LinearProgress.defaultProps = {
  max: 100,
  label: '',
  color: '#FFCC03',
  width: '100%',
  height: '10px',
  bullets: {}
};
export default LinearProgress;